import Vue from "vue";
import Vuex from "vuex";
import VueCookies from "vue-cookies";

Vue.use(Vuex);
Vue.use(VueCookies);
let vue = new Vue();

export default new Vuex.Store({
  state: {
    loggedIn: vue.$cookies.get("token") != null
  },
  mutations: {
    setLoggedIn(state, value: boolean) {
      state.loggedIn = value;
    }
  },
  actions: {
    setLoggedIn(context, value: boolean) {
      context.commit("setLoggedIn", value);
    }
  },
  modules: {}
});
